import React from 'react';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import { useNavigate } from 'react-router';
import Text from 'components/Text';
import Icon from 'components/Icon';
import Map from './Map';
import AddressAndPhones from 'components/AddressAndPhones';
import ContactsFeedbackFormBlock from './ContactsFeedbackFormBlock';
import Mediatek from 'components/Mediatek';
import './index.sass';

const { block, el } = bem('contacts')

const Contacts = () => {
    const navigate = useNavigate();
    const { isMobile } = useMobile();
    const goBack =
        window.history.state && window.history.state.idx > 0 ?
            () => navigate(-1) :
            () => navigate('/', { replace: true })

    const center = isMobile ? [ 55.775, 37.594688 ] : [ 55.7745, 37.593 ];

    return (
        <div className={block()}>
            <div className={el('map')}>
                <Map center={center}/>
            </div>
            <div className={ el('container') }>
                <div className={el('header')}>
                    <div className={ el('go-back') } onClick={ goBack }>
                        <Icon name='arrow-left'/>
                        <Text>Вернуться назад</Text>
                    </div>
                    <div className={ el('title')}>
                        <Text serif>Контакты</Text>
                    </div>
                </div>
                <div className={el('map-overlay')}>
                    <div className={el('phones')}>
                        <AddressAndPhones mod={'full'} />
                    </div>
                    <div className={el('working-hours-wrap')}>
                        <div className={el('working-hours')}>
                            <div className={el('working-hours-label')}><Text>Часы работы офиса «Ответ»:</Text></div>
                            <div className={el('working-hours-value')}>
                                <div className={el('working-hours-block')}>
                                    <div className={el('working-hours-block-days')}>
                                        <div>ПН-ПТ</div>
                                        <div>СБ</div>
                                        <div>ВС</div>
                                    </div>
                                    <div className={el('working-hours-block-hours')}>
                                        <div>11:00 — 21:00</div>
                                        <div>11:00 — 14:00</div>
                                        <div>11:00 — 17:00</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className={ el('content') }>
                <div className={el('feedback-form')}>
                    <ContactsFeedbackFormBlock />
                </div>
                <div className={ el('mediatek') }>
                    <Mediatek title={'Мы в социальных сетях'}/>
                </div>
            </div>
        </div>
    )
}
export default Contacts;
